import { call, put, takeLatest, takeLeading } from 'redux-saga/effects';
import MaintenanceManagementService from '../api/maintenaceMangement';
import { maintenanceManagementActions } from '../reducers/maintenance-management';

function* getMaintenacePlanData({ payload }: any): any {
  const res = yield call(MaintenanceManagementService.getMaintenacePlan, payload);
  if (res.status === 'success') {
    yield put(maintenanceManagementActions.getMaintenaceListResponse(res.res));
  } else {
    yield put(maintenanceManagementActions.getMaintenanceListFailed(res?.code));
  }
}

function* getActivityListData({ payload }: any): any {
  const res = yield call(MaintenanceManagementService.getAllActivities, payload);
  if (res.status === 'success') {
    yield put(maintenanceManagementActions.getActivityListResponse(res.res));
  } else {
    yield put(maintenanceManagementActions.getActivityListFailed(res?.code));
  }
}

function* getMaintenanceHistoryData({ payload }: any): any {
  const res = yield call(MaintenanceManagementService.getMaintenanceHistory, payload);
  if (res.status === 'success') {
    yield put(maintenanceManagementActions.getMaintenanceHistoryResponse(res.res));
  } else {
    yield put(maintenanceManagementActions.getMaintenanceHistoryFailed(res?.code));
  }
}

function* getActivityHistoryData({ payload }: any): any {
  const res = yield call(MaintenanceManagementService.getActivityHistory, payload);
  if (res.status === 'success') {
    yield put(maintenanceManagementActions.getActivityHistoryResponse(res.res));
  } else {
    yield put(maintenanceManagementActions.getActivityHistoryFailed(res?.code));
  }
}

function* addActivityData({ payload }: any): any {
  const res = yield call(MaintenanceManagementService.addActivity, payload);
  if (res.status === 'success') {
    yield put(maintenanceManagementActions.addActivityResponse(res.res));
  } else {
    yield put(maintenanceManagementActions.addActivityRequestFailed(res.res));
  }
}

function* updateActivityData({ payload }: any): any {
  const res = yield call(MaintenanceManagementService.updateActivity, payload);
  if (res.status === 'success') {
    yield put(maintenanceManagementActions.updateActivityResponse(res.res));
  } else {
    yield put(maintenanceManagementActions.updateActivityRequestFailed(res.res));
  }
}

function* getActivityData({ payload }: any): any {
  const res = yield call(MaintenanceManagementService.getActivityById, payload);
  if (res.status === 'success') {
    yield put(maintenanceManagementActions.getActivityResponse(res.res));
  } else {
    yield put(maintenanceManagementActions.getActivityFailed(res?.code));
  }
}

function* deleteActivity({ payload }: any): any {
  const res = yield call(MaintenanceManagementService.deleteActivity, payload);
  if (res.status === 'success') {
    yield put(maintenanceManagementActions.deleteActivityResponse(res.res));
  } else {
    yield put(maintenanceManagementActions.deleteActivityRequestFailed(res));
  }
}

function* addMaintenacePlan({ payload }: any): any {
  const res = yield call(MaintenanceManagementService.addMaintenacePlan, payload);
  if (res.status === 'success') {
    yield put(maintenanceManagementActions.addMaintenancePlanResponse(res.res));
  } else {
    // console.log(res.res, res, 'RESPONSE')
    yield put(maintenanceManagementActions.addMaintenancePlanRequestFailed(res));
  }
}

function* getMaintenacePlan({ payload }: any): any {
  const res = yield call(MaintenanceManagementService.getMaintenacePlanById, payload);
  if (res.status === 'success') {
    yield put(maintenanceManagementActions.getMaintenancePlanResponse(res.res));
  } else {
    yield put(maintenanceManagementActions.getMaintenancePlanRequestFailed(res.res));
  }
}

function* updateMaintenacePlan({ payload }: any): any {
  const res = yield call(MaintenanceManagementService.updateMaintenacePlan, payload);
  if (res.status === 'success') {
    yield put(maintenanceManagementActions.updateMaintenancePlanResponse(res.res));
  } else {
    yield put(maintenanceManagementActions.updateMaintenancePlanRequestFailed(res.error));
  }
}

function* downloadDocument({ payload }: any): any {
  const res = yield call(MaintenanceManagementService.downloadDocument, payload);
  if (res.status === 'success') {
    yield put(maintenanceManagementActions.downloadDocumentResponse(res.res));
  } else {
    yield put(maintenanceManagementActions.downloadDocumentRequestFailed(res?.code));
  }
}

function* deletePlans({ payload }: any): any {
  const res = yield call(MaintenanceManagementService.deleteMaintenancePlan, payload);
  if (res.status === 'success') {
    yield put(maintenanceManagementActions.deletePlanResponse(res.res));
  } else {
    yield put(maintenanceManagementActions.deletePlanRequestFailed(res.error));
  }
}

function* getEngineers({ payload }: any): any {
  const res = yield call(MaintenanceManagementService.fetchEngineersList, payload);
  if (res.status === 'success') {
    yield put(maintenanceManagementActions.getEngineersResponse(res.res));
  } else {
    yield put(maintenanceManagementActions.getEngineersRequestFailed(res.res));
  }
}

function* getMaintenaceTaskData({ payload }: any): any {
  if(payload.mt_filter && payload.mt_filter==='corrective'){
    const res = yield call(MaintenanceManagementService.getMaintenacePlan, payload);
    // if (res.status === 'success') {
    //   yield put(maintenanceManagementActions.getMaintenaceListResponse(res.res));
    // } else {
    //   yield put(maintenanceManagementActions.getMaintenanceListFailed(res?.code));
    // }
    // let res = yield call(MaintenanceManagementService.viewAllMaintenancePlan, payload);
    if (res.status === 'success') {
      yield put(maintenanceManagementActions.getMaintenaceTaskResponse(res.res));
    } else {
      yield put(maintenanceManagementActions.getMaintenanceTaskFailed(res?.code));
    }
  } else {
    let res = yield call(MaintenanceManagementService.viewAllMaintenancePlan, payload);
    if (res.status === 'success') {
      yield put(maintenanceManagementActions.getMaintenaceTaskResponse(res.res));
    } else {
      yield put(maintenanceManagementActions.getMaintenanceTaskFailed(res?.code));
    }
  }
}

function* getCheckMachineRequest({ payload }: any): any {
  const res = yield call(MaintenanceManagementService.checkMachineOntology, payload);
  if (res.status === 'success') {
    yield put(maintenanceManagementActions.checkMachineResponse(res));
  } else {
    yield put(maintenanceManagementActions.checkMachineFailed(res?.code));
  }
}

//checkMachineRequest

function* MaintenanceManagementSaga() {
  yield takeLatest('maintenanceManagement/getMaintenaceListRequest', getMaintenacePlanData);
  yield takeLatest('maintenanceManagement/getActivityListRequest', getActivityListData);
  yield takeLatest('maintenanceManagement/getMaintenanceHistoryRequest', getMaintenanceHistoryData);
  yield takeLatest('maintenanceManagement/getActivityHistoryRequest', getActivityHistoryData);
  yield takeLeading('maintenanceManagement/addActivityRequest', addActivityData);
  yield takeLeading('maintenanceManagement/getActivityRequest', getActivityData);
  yield takeLeading('maintenanceManagement/deleteActivityRequest', deleteActivity);
  yield takeLeading('maintenanceManagement/updateActivityRequest', updateActivityData);
  yield takeLeading('maintenanceManagement/addMaintenancePlanRequest', addMaintenacePlan);
  yield takeLeading('maintenanceManagement/getMaintenancePlanRequest', getMaintenacePlan);
  yield takeLeading('maintenanceManagement/updateMaintenancePlanRequest', updateMaintenacePlan);
  yield takeLeading('maintenanceManagement/downloadDocumentRequest', downloadDocument);
  yield takeLeading('maintenanceManagement/deletePlanRequest', deletePlans);
  yield takeLeading('maintenanceManagement/getEngineersRequest', getEngineers);
  yield takeLatest('maintenanceManagement/getMaintenaceTaskRequest', getMaintenaceTaskData);
  yield takeLatest('maintenanceManagement/checkMachineRequest', getCheckMachineRequest);
}

export default MaintenanceManagementSaga;
